/**
 * Convert any color format to hex
 * @param {string} color
 * @param {number} alpha
 * @returns {string} a valid hex color (can contain alpha)
 */
export function colorInHex(color, alpha) {
  const canvas = document.createElement("canvas")
  const context = canvas.getContext("2d")
  context.fillStyle = color

  if (!context.fillStyle.startsWith("#")) {
    const rgb = RGBAtoRGB(context.fillStyle)
    return applyAlphaToHex(colorInHex(rgb), getColorAlpha(context.fillStyle))
  }

  return applyAlphaToHex(context.fillStyle, alpha)
}

/**
 * Convert any color format to RGBA
 * @param {string} color
 * @param {number} alpha
 * @returns {string} a valid rgba color
 */
export function colorInRGBA(color, alpha) {
  const hex = colorInHex(color)

  const [r, g, b] = hex.match(/\w{2}/g).map(c => parseInt(c, 16))
  return `rgba(${r},${g},${b},${alpha ?? getColorAlpha(color)})`
}

export function getColorAlpha(color) {
  if (color === "transparent") return 0
  if (color.startsWith("#")) {
    const alpha = parseInt(color.slice(7), 16) / 255
    return !isNaN(alpha) && alpha < 1 ? Number(alpha.toFixed(2)) : 1
  }

  const split = color.match(/\.?[\d\\.]+/g) || []
  if (split.length < 4) return 1

  const result = Number(parseFloat(split[3]).toFixed(2)) ?? 1
  return result
}

export function applyAlphaToHex(hex, alpha) {
  if (isNaN(alpha) || alpha === 1) return hex
  const padding = alpha === 0 ? 2 : 1
  return `${hex}${Math.round(alpha * 255)
    .toString(16)
    .padEnd(padding, "0")}`
}

export function RGBAtoRGB(color) {
  return color.replace(/,\s*\d?[\d\\.]+(?=\)$)/, "").replace("rgba", "rgb")
}
